// utils/textUtils.js

/**
 * Truncate text to a specified number of words and append ellipses if truncated.
 * @param {string} text - The text to truncate.
 * @param {number} wordLimit - The maximum number of words to display.
 * @returns {string} - The truncated text.
 */
export const truncateText = (text, wordLimit = 3) => {
    const words = text.split(" ");
    return words.length > wordLimit ? `${words.slice(0, wordLimit).join(" ")}...` : text;
  };
  